import React, { useEffect } from 'react';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-8">Cookie Policy</h1>
        <div className="prose prose-slate max-w-none text-slate-600 leading-relaxed space-y-6">
          <p className="text-lg">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">1. What Are Cookies</h2>
          <p>
            As is common practice with almost all professional websites, this site uses cookies, which are tiny files 
            that are downloaded to your computer, to improve your experience. This page describes what information they gather, 
            how we use it and why we sometimes need to store these cookies.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">2. How We Use Cookies</h2>
          <p>
            We use cookies for a variety of reasons detailed below. Unfortunately, in most cases, there are no industry 
            standard options for disabling cookies without completely disabling the functionality and features they add to this site.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">3. The Cookies We Set</h2>
          <ul className="list-disc pl-6 space-y-4">
            <li>
              <strong>Site preferences cookies:</strong> In order to provide you with a great experience on this site, we provide the 
              functionality to set your preferences for how this site runs when you use it. In order to remember your preferences, 
              we need to set cookies so that this information can be called whenever you interact with a page.
            </li>
            <li>
              <strong>Third Party Cookies:</strong> In some special cases we also use cookies provided by trusted third parties. 
              For example, this site uses Google Analytics which is one of the most widespread and trusted analytics solutions on 
              the web for helping us to understand how you use the site and ways that we can improve your experience.
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">4. Disabling Cookies</h2>
          <p>
            You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). 
            Be aware that disabling cookies will affect the functionality of this and many other websites that you visit.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;